import {View} from 'react-native';
import * as React from 'react';
import {Props} from './model';
import {useStyles} from '../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {PollVoteResultItem} from '../voteResultItem';
import {Text} from '../../../../shared/components/text';
import {useIsDesktop} from '../../../../shared/hooks/useIsDesktop';

export default ({isVoteCompleteNow, poll}: Props) => {
  const styles = useStyles(({theme, mediaOnly}) => ({
    container: {},
    title: {
      ...mediaOnly(
        DeviceSize.desktop,
        {...theme.fonts.h2, marginBottom: 30},
        {...theme.fonts.h6, marginBottom: 30, color: theme.color.primaryColor},
      ),
      textAlign: 'center',
    },
    subtitle: {
      ...mediaOnly(
        DeviceSize.desktop,
        {...theme.fonts.h3Light, marginBottom: 42},
        {...theme.fonts.action, marginBottom: 30},
      ),
      textAlign: 'center',
    },
    answer: {
      marginBottom: 30,
    },
    lastAnswer: {
      marginBottom: 15,
    },
  }));
  const isDesktop = useIsDesktop();
  const title = isVoteCompleteNow ? 'Спасибо за участие в голосовании!' : isDesktop ? poll.name : null;

  return (
    <View style={styles.container}>
      {title ? <Text style={styles.title}>{title}</Text> : null}
      <Text style={styles.subtitle}>Текущие результаты</Text>
      <View>
        {poll?.questions?.map((item, itemIndex) => {
          const sum = item?.answers?.reduce((p, c) => p + (c?.numberResponses || 0), 0) || 0;
          return (
            <View key={item.id}>
              {item?.answers?.map((answer, answerIndex) => (
                <PollVoteResultItem
                  style={
                    itemIndex === (poll?.questions?.length ?? 0) - 1 && answerIndex === (item?.answers?.length ?? 0) - 1
                      ? styles.lastAnswer
                      : styles.answer
                  }
                  key={answer.id}
                  total={sum}
                  text={answer?.text || ''}
                  value={answer?.numberResponses || 0}
                />
              ))}
            </View>
          );
        })}
      </View>
    </View>
  );
};
